<template>
 <div class="app-container">
   <div class="formBox margbot"  ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
        <el-form-item label="捆包编号:" >
          <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.cargoBarcode" ></el-input>
        </el-form-item>
        <!-- <el-form-item label="货权客户:">
          <el-input placeholder="" v-model="searchFrom.customerName" ></el-input>
        </el-form-item> -->
        <el-form-item label="货物类型:" >
          <el-select  v-model="searchFrom.productTypeName" filterable placeholder="请选择">
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同编号:">
          <el-input placeholder="" v-model="searchFrom.contractNumber" ></el-input>
        </el-form-item>
         <el-form-item label="合约编号:">
          <el-input placeholder="" v-model="searchFrom.agreementNumber" ></el-input>
        </el-form-item>
        <el-form-item label="创建时间:" class="item2" >
          <el-date-picker
              v-model="searchFrom.createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
               :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        </div>
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"  v-if="btnFlg[1]" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[2]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
            <el-form-item style="margin-left:8px">
              <p class="margin0" >总重量:<span class="red">{{sum.allWeight}}</span>吨</p>
            </el-form-item>
            <el-form-item style="margin-left:8px">
              <p class="margin0" >总数量:<span class="red">{{sum.allNumber}}</span>件</p>
            </el-form-item>
            <el-form-item style="margin-left:8px">
              <p class="margin0" >总体积:<span class="red">{{sum.allVolumn}}</span>方</p>
            </el-form-item>
          </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <el-table-column property=""  width="100" label="状态" >
          <template slot-scope="scope">
            <span style="color: #E99D42;" v-if="scope.row.wayState=='运输中'" >{{scope.row.wayState}}</span>
            <span style="color: #D51212;" v-else-if="scope.row.wayState=='待签收'" >{{scope.row.wayState}}</span>
            <span style="color: #81B337;" v-else-if="scope.row.wayState=='已签收'" >{{scope.row.wayState}}</span>
            <span style="color: #9A9A9A;" v-else-if="scope.row.wayState=='已作废'" >{{scope.row.wayState}}</span>
            <span  v-else >{{scope.row.wayState}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
             min-width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
          width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"
          align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
          min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
          min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
          min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
             min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
             min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="wayNo" label="运单号" align="center"
             width="240"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNnumber" label="车牌号" align="center"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center"
          min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverPhone" label="司机电话" align="center"
          min-width="120"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
        <el-table-column prop="actualLoadingTime" label="实际装车时间" :formatter="dateTimeFormat" width="170"></el-table-column>
        <el-table-column prop="actualUnloadingTime" label="实际卸车时间" :formatter="dateTimeFormat" width="170"></el-table-column>
        <el-table-column prop="actualSigningTime" label="实际签收时间" :formatter="dateTimeFormat" width="170"></el-table-column>

      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getDictionaryDetailList, findWayGoodsList } from '@/api/newTMS'
export default {
  components: {
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      HWlist: [],
      loading: false,
      isDisable: false,
      sum: {},
      btnFlg: [],
      btnIdArr: ['01N0170100', '01N0170200', '01N0170300']

    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    this.btnFlg = getBtn(this.btnIdArr, '/goodTrack')
    this.$set(this.searchFrom, 'createTimes', getLastMonth())
    this.searchFn()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 162) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.tmsPlus + '/way/exportWayGoodsList',
        form,
        '货物追踪'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
      that.weight = that.weight.toFixed(3)
      this.num = selection.length
    },
    // 点击选中
    handleRowClick (row, column, event) {
      if (row.status == '未配载') {
        this.$refs.table.toggleRowSelection(row)
      }
    },
    // 获取列表
    getList () {
      this.loading = true
      findWayGoodsList(this.searchFrom).then(res => {
        this.tableList = res.pageInfo.list
        this.total = res.pageInfo.total
        this.sum = res.sum
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.$set(this.searchFrom, 'createTimes', getLastMonth())
    },
    closeDialog () {
      this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 430px!important;
}
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 280px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
</style>
